/**
 * Nav points the system layout does not hold (M9 CH-14a, plan `docs/plans/2026-10-05-m9-claimable-hulls.md` H-9):
 * the `hulk` nav target kind. A feature lists the current system's points (found hulks, `features/hulks`) and the
 * travel resolver (`travel/runtime/nav.ts resolveNavTarget`) and the HUD labels read them by id. Only the last
 * system's list is held; another system's id resolves to nothing, so a stale target is dropped like any other.
 * Event-driven: set on system entry and on a ping that finds something, read when the nav target is refreshed.
 */
import type { Vec3T } from '../galaxy/layout/types'

export interface NavPoint {
  readonly id: string
  /** What the HUD calls it ("Hulk · Interceptor"). */
  readonly name: string
  /** System frame, float64 metres. */
  readonly position: Vec3T
}

let pointsSystem: string | null = null
const points = new Map<string, NavPoint>()

/** Replaces the nav points of `systemId` (an empty list clears them). */
export function setNavPoints(systemId: string, list: readonly NavPoint[]): void {
  pointsSystem = systemId
  points.clear()
  for (const p of list) points.set(p.id, p)
}

/** The nav point `id` of `systemId`, or undefined (unknown, or another system's). */
export function navPointOf(systemId: string, id: string): NavPoint | undefined {
  return systemId === pointsSystem ? points.get(id) : undefined
}

/** Clears every point (dispose, tests). */
export function clearNavPoints(): void {
  pointsSystem = null
  points.clear()
}
